<template>
  <div>
    <h3 class="m-0 text-gray-900 flex-grow-1 mb-5">Alterar retenção</h3>
    <Button class="btn btn-info" v-if="!enableRetentionChange" @click="enableRetentionChange = true">Alterar</Button>
    <div class="d-flex align-items-center gap-3" v-if="enableRetentionChange">
      <div class="col-2">
        <input type="number" class="form-control form-control-sm" min="65" max="99" step="1" v-model="retention" />
      </div>
      <Button class="btn btn-primary btn-sm" :loading="loaderRetention" @click="updateRetention()">Salvar</Button>
    </div>
  </div>
</template>

<script>

import Button from '@/components/common/Button/Button'
import CampaignsService from '@/modules/campaigns/services/campaigns-service'
import NotificationsService from '@/modules/notifications/services/notifications-service'

export default {
  name: 'UpdateRetentionForm',
  props: ['campaign'],
  components: {
    Button
  },
  data () {
    return {
      loader: false,
      retention: 0,
      enableRetentionChange: false,
      loaderRetention: false
    }
  },
  created () {
    this.retention = this.campaign.retention
  },
  methods: {
    /*
     *  update retention
     */
    async updateRetention () {
      this.loaderRetention = true
      try {
        await CampaignsService.updateRetention(this.campaign.id, this.retention)
        const notification = {
          notification: {
            type: 'success',
            content: 'Retenção alterada com sucesso!'
          }
        }
        NotificationsService.createGlobalSuccessNotification(notification)
        this.enableRetentionChange = false
        this.$emit('update')
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loaderRetention = false
    }
  }
}
</script>
